import Vue from 'vue'
import App from './App'
import moment from 'moment'
import accounting from 'accounting'
import router from './router'
import Cookie from 'vue-cookie'
import Resource from 'vue-resource'
import VTooltip from 'v-tooltip'
import VueLocalForage from 'vue-localforage'
import VueSimpleAlert from "vue-simple-alert";
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/tr';

import { SweetModal, SweetModalTab } from 'sweet-modal-vue'

import oauth from '@/mixins/oauth2'
Vue.mixin(oauth);

Vue.component('SweetModal', SweetModal)
Vue.component('SweetModalTab', SweetModalTab)
Vue.use(SweetModal)
Vue.use(SweetModalTab)
Vue.use(DatePicker);
Vue.use(VueSimpleAlert);
Vue.use(VTooltip);
Vue.directive('tooltip', VTooltip.VTooltip);

window.scheme = 'https:';
window.search = window.scheme+'//bs.co/'
window.apphost = 'vivo90.com';
window.api = '';
window.wsapi = 'wss://plysport.com/';
window.bsapi = window.scheme+'//api.'+getCanonicalHost(window.location.hostname)+'/';
//window.bsapi = location.protocol+'//plysport.com/';
window.session = new Object;
window.loading = 0;
window.csapi = 'https://client.plygaming.dev/';
//window.bsapi = 'https://eu.plysport.com/';

if (window.location.hostname == 'localhost') {
    window.scheme = 'http:';
    window.apphost = 'sp.co';
    //window.apphost = 'tip24.bet';
    //window.apphost = 'xkart.bahigo255.xyz';
    //window.wsapi = 'ws://bs.co';
    //window.bsapi = window.scheme+'//bs.co/';
    // window.bsapi = 'https://plysport.com/';
    //window.bsapi = 'https://eu.plysport.com/';
    window.bsapi = window.scheme+'//bs.co/';
    window.search = 'http://bs.co/'
    //window.apphost = 'vivobahis.com';
}

window.auth = new Object;

var language = window.location.pathname.replace(/^\/([^\/]+).*/i,'$1');
window.locale = (language != '/') ? language : defaultLocale

window.userLang = navigator.language || navigator.userLanguage;

window.accessTokenHeader = null;
Vue.use(VueLocalForage)
Vue.use(Resource)
Vue.use(Cookie)
Vue.config.productionTip = false;

Vue.http.options.emulateJSON = true;

Vue.http.interceptors.push((request, next) => {

    function getCookie(name) {
        function escape(s) {
            return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
        };
        var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
        return match ? match[1] : null;
    }

    if (request.url.match(bsapi)) {
        request.headers.set('X-App-Session', 'Bearer ' + window.auth.accessToken);
    } else if (!request.url.match('api/v1/get/client') && window.auth.accessToken) {
        if (window.auth.accessToken)
            request.headers.set('Authorization', 'Bearer ' + window.auth.accessToken);
    }
    //request.headers.set('Accept-Language', window.locale);
    request.params.locale = window.locale;
    next()
})

const EventBus = new Vue()

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function () {
            return EventBus
        }
    }
})

/* eslint-disable no-new */
var vm = new Vue({
    el: '#app',
    router,
    data: {
        moment: moment,
        windowWidth: document.body.clientWidth
    },
    template: '<App />',
    components: {App},
    watch: {
        windowWidth(newWidth, oldWidth) {}
    },
    mounted() {
        this.$nextTick(() => {
            window.addEventListener('resize', this.onResize);
        })
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.onResize);
    },
    methods: {
        onResize() {
            this.windowWidth = document.body.clientWidth
        }
    }
})


var mixin = {
    methods: {
        generatePassword (max) {
            return Math.floor(Math.random() * max) + '' + Math.floor(Math.random() * max)
                + '' + Math.floor(Math.random() * max) + '' + Math.floor(Math.random() * max);
        },
        globalLoader(load) {
            window.loading = load;
        },
        findByKeyAndRemove(source, key, id) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source.splice(key, 1);
                }
            }
            return false;
        },
        findByKeyAndReplace(source, key, id, data) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === id) {
                    source[i] = data;
                } else {
                    source.push(data);
                }
            }
            return false;
        },
        findByKey(source, key, find) {
            for (var i = 0; i < source.length; i++) {
                if (source[i][key] === find) {
                    return source[i];
                }
            }
            return false;
        },

        uformat(str, args) {
            if (args && str) {
                for (var key in args) {
                    str = str.replace(new RegExp("\\%" + key + "\\%", "gi"), args[key]);
                }
            }

            return str;
        },
        sortByKey(array, key) {
            var array = Object.values(array);
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return ((x < y) ? 1 : ((x > y) ? -1 : 0));
            });
        },
        sortAByKey(array, key) {
            var array = Object.values(array);
            return array.sort(function (a, b) {
                var x = a[key];
                var y = b[key];
                return ((x > y) ? 1 : ((x < y) ? -1 : 0));
            });
        },
        periodTimer (m) {

            if(m.periodTimeLeft != 0){

                return m.periodTimeLeft;

            }else if(m.periodTime > 0){

                var min = (parseInt((m.periodTime / 60).toFixed(0)) + 1);

                if(m.resultName == "1st half" && m.periodTime >= 2700)
                    return "45' +"+Math.abs(45 - min);

                if(m.resultName == "2nd half" && m.periodTime >= 5400)
                    return "90' +"+Math.abs(90 - min);

                return (min > 0) ? min+"'" : '';
            }

            if(m.periodCounter > 0){
                const min = (m.roundCounter / 3600).toFixed(2);

                return (min > 0) ? min+"'" : '';
            }
        },
        phpToMoment(str) {
            let replacements = {
                'd' : 'DD',
                'D' : 'ddd',
                'j' : 'D',
                'l' : 'dddd',
                'N' : 'E',
                'S' : 'o',
                'w' : 'e',
                'z' : 'DDD',
                'W' : 'W',
                'F' : 'MMMM',
                'm' : 'MM',
                'M' : 'MMM',
                'n' : 'M',
                't' : '', // no equivalent
                'L' : '', // no equivalent
                'o' : 'YYYY',
                'Y' : 'YYYY',
                'y' : 'YY',
                'a' : 'a',
                'A' : 'A',
                'B' : '', // no equivalent
                'g' : 'h',
                'G' : 'H',
                'h' : 'hh',
                'H' : 'HH',
                'i' : 'mm',
                's' : 'ss',
                'u' : 'SSS',
                'e' : 'zz', // deprecated since Moment.js 1.6.0
                'I' : '', // no equivalent
                'O' : '', // no equivalent
                'P' : '', // no equivalent
                'T' : '', // no equivalent
                'Z' : '', // no equivalent
                'c' : '', // no equivalent
                'r' : '', // no equivalent
                'U' : 'X'
            };

            return str.split('').map(chr => chr in replacements ? replacements[chr] : chr).join('');
        },
        dateTimeFormat (date) {
            var stillUtc = window.moment.utc(date).toDate();
            var local = window.moment(stillUtc).local().format(this.phpToMoment(session.date_time_format));
            return local
        },
        moment(d) {
            return window.moment(d)
        },
        getCookie() {
            function escape(s) {
                return s.replace(/([.*+?\^${}()|\[\]\/\\])/g, '\\$1');
            };
            var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
            return match ? match[1] : null;
        },
        getWindowSize() {
            window.addEventListener("resize", function (event) {
                //console.log(document.body.clientWidth + ' wide by ' + document.body.clientHeight+' high');
                return document.body.clientWidth
            })
        }
    },
    filters: {
        toHHMMSS: function (a, p, r) {
            if (r == 18 || r == 7) {
                return ' ';
            }
            var now = Math.round(+new Date() / 1000);

            var seconds = (moment(a).unix() - moment.unix(p));

            var pt = moment().diff(moment.unix(a), 'minutes')

            var add = (r != 13) ? 45 : 0;
            // 1

            return (add + moment.unix(now).diff(moment.unix(a), 'minutes')) + "'";

        },
        uformat: function (str, args) {

            args.forEach(myFunction)

            for (var a in args) {
                str = str.replace(new RegExp("\\%" + a.key + "\\%", "gi"), a);
            }


            return unescape(str);
        },
        toMoney: function (val,currency,symbol = true) {

            if (!currency)
                return false;

            let formatConfig = "%s %v"


            if (currency.position === 'before'){
                formatConfig = "%s %v";
            } else {
                formatConfig = "%v %s";
            }

            var mony = accounting.formatMoney(val, {
                format:  formatConfig,
                symbol: currency.symbol,
                precision : 2,
                thousand : ',',
                decimal : '.',
            });

            if(currency.position == 'before'){
                if(symbol) {
                    return mony;
                }else {
                    return currency.iso_code+' '+mony;
                }
            }else {
                if(symbol) {
                    return mony;
                }else {
                    return mony+' '+currency.iso_code;
                }
            }
        },
        moment: function (date, format, tz) {

            if (tz === undefined || tz === null) {
                var zone_name = window.moment.tz.guess();
                var timezone = window.moment.tz(zone_name).zoneAbbr()

                var tz = timezone;
            }

            if (format === 'undefined' || format === null) {
                var format = 'M/D/Y HH:mm:ss';
            }
            if (date) {
                return (format && tz) ? window.moment(date).format(format, {trim: false}) : date;
            }
        },
        tz: function (dt, tz, format, ago = true) {
            window.moment.tz.add(tz)
            if (ago) {
                return (dt && tz) ? window.moment(dt).fromNow() : '--'; // 5 years ago
            } else {
                return (dt && tz) ? window.moment(dt).format(format, {trim: false}) : '--'; // 5 years ago
            }
        },
        timeAgo: function (dt) {
            //window.moment.tz.add(window.session.date_time_format);
            return (dt) ? window.moment(dt).fromNow() : '';
        },
        slimiter: function (str, limit) {
            return (limit && str.length > limit) ? str.substring(0, limit) + '...' : str;
        },
        nPlus: function (number) {
            return (number > 90) ? '90+' : number;
        },
        arrayFragmentation: function (Array, n = 6) {
            var count = Array.length;
            var newArray = new Array();

            for (i = 0; i <= count;) {
                newArray[i] = Array.slice(i, n);
                i++;
            }
        },
    }
}

Vue.mixin(mixin);
Array.prototype.remByVal = function (val) {
    for (var i = 0; i < this.length; i++) {
        if (this[i] === val) {
            this.splice(i, 1);
            i--;
        }
    }
    return this;
}




// WEBPACK FOOTER //
// ./src/main.js